"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhoWeAre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="36554" id="the-standard-behind-the-service" ref={ref} className={`bg-background text-foreground py-20 lg:py-[150px] overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {/* Image Column */}
          <div className="col-span-1 lg:col-span-6 relative">
            <div className="relative border-t border-primary/40 p-2 sm:p-4">
              <AspectRatio ratio={3 / 4} className="bg-muted rounded-sm overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598014/img/mercedes_s_class_interior.png" alt="Mercedes-Benz S-Class Luxury Interior" className="h-full w-full object-cover" />
              </AspectRatio>
            </div>
          </div>

          {/* Text Content Column */}
          <div className="col-span-1 lg:col-span-5 lg:col-start-8 flex flex-col gap-8">
            <div className="space-y-4">
              <span className="font-mono text-primary text-sm tracking-[0.2em] block uppercase">
                ESTABLISHED 2016
              </span>
              <h2 className="font-default font-extrabold text-3xl sm:text-4xl lg:text-5xl bg-gradient-to-br from-foreground via-foreground to-muted-foreground bg-clip-text text-transparent leading-tight">
                The Standard Behind the Service
              </h2>
            </div>

            <div className="space-y-6">
              <p className="font-sans text-muted-foreground text-base sm:text-lg leading-[1.8]">
                Since our inception in 2016, we have redefined the essence of luxury travel 
                in the region. Our commitment to excellence is reflected in every mile, 
                ensuring that our clients experience the pinnacle of comfort and sophistication 
                through our bespoke chauffeur services.
              </p>
              
              <p className="font-sans text-muted-foreground text-base sm:text-lg leading-[1.8]">
                Our fleet represents the zenith of automotive engineering, maintained to 
                exacting standards that surpass industry expectations. We believe that true 
                luxury lies in the details—the seamless transition, the silent cabin, and the 
                unwavering reliability of our professional service.
              </p>
            </div>

            <div className="pt-4">
              <p className="font-default font-bold text-primary text-xl italic">
                "Precision in every detail, prestige in every journey."
              </p>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="uppercase tracking-widest font-semibold rounded-none bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
                <Link to="/OurFleetAboutUsContactPage">
                  Read More <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}